// extracted by mini-css-extract-plugin
export default {"mediaVideoBlock":"media-video-ui_mediaVideoBlock__EFIYk"};